import { ModuleProps, CreateModuleProps } from "components";
import { Routes } from "./Routes";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "SETTINGS_PILOT_TRANSPORT_CONTACT",
    parentId: "SETTINGS_PARENT",
    applicationRights: Rights,
    title: 'Kontaktinformasjon',
    text: 'Kontaktinformasjon',
    icon: 'gear',
    showOnDashboardByDefault: false,
    url: "/settings/ptc",
    routes: Routes
})
